import React from 'react';
import css from './Modal.less';

const TopContainer = (props) => {
  const { children, className } = props;
  return <div className={`${css.topContainer} ${className}`}>{children}</div>;
};
export default TopContainer;
